<div class="search-wrapper-page">
    <div class="search-container col-12">

        <div class="search-box col-9">
            <label for="search" class="search-label" style="float: left;">Search for documents, videos and resources:</label>
            <form action="">
                <input type="search" #autoCompleteInput name="keyword" [(ngModel)]="searchText" (keyup)="onSearchTextChange(searchText)"
                    (keydown.enter)="onSearchTextEnter(searchText)" placeholder="Type here to search" [matAutocomplete]="auto"
                    class="search-input" id="search">
            </form>
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSearchTextEnter(searchText);">
                <mat-option *ngFor="let option of searchAutoSuggestions" [value]="option">
                    {{ option }}
                </mat-option>
            </mat-autocomplete>
            <button [hidden]=" (searchText ==='') || (this.windowWidth<768) " class="search-submit-btn" (click)="onSearchTextEnter(searchText)">
                Go
            </button>

        </div>
        <div class="close-wrapper col-3">
            <button class="close search-close-button" (click)="onCloseSearchPage();">
                <svg class="tcom-icon tcom-icon-btn-close-large" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px" y="0px" width="45px" height="45px" viewBox="0 0 45 45" enable-background="new 0 0 45 45" xml:space="preserve">
                    <g>
                        <polygon points="43.555,45 45,43.556 23.945,22.5 45,1.445 43.555,0 22.5,21.056 1.445,0 0,1.446 21.055,22.5 0,43.556 1.445,45 22.5,23.945 "></polygon>
                    </g>
                </svg>
            </button>

        </div>
    </div>
</div>